import React from 'react';
import { isEmpty, get } from 'lodash';
import { withRouter } from 'react-router-dom';

// local dependencies
import { priorAuthDetail as PriorAuthDetailView } from 'ui/views/widgets/priorAuthDetail';
import { PriorAuthDetailService } from 'services/priorAuthDetail';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as backRoute from 'utils/backRoute';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { PriorAuthDetail } from 'ui/containers/PriorAuthDetail';
 *
 * // render
 * <PriorAuthDetail propName='propValue'/>
 */
class _PriorAuthDetail extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.priorAuthDetailService = new PriorAuthDetailService();

        this.data = {
            memberId: get( this.props.location, 'state.memberId', null ),
            patientId: get( this.props.location, 'state.patientId', null )
        };

        this.state = {
            isFetching: true,
            networkStatus: null,
            componentData: null
        };

        this.fetchComponentData();
    }

    fetchComponentData = async () => {
        log.debug( 'PriorAuthDetail.fetchComponentData()' );

        this.priorAuthDetailService.cancel();

        const { status, data } = await this.priorAuthDetailService.fetchComponentData( {
            url: this.props.widget.url
        } );

        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data
            } );
        }
    }

    handleNavActionClick = ( { type, value } ) => {
        log.debug( 'PriorAuthDetail.handleNavActionClick()' );

        if( 'headerAction' === type && 'back' === value.name ) {

            // get back-route payload
            const backRoutePayload = backRoute.decode( this.props.location );

            if( ! isEmpty( backRoutePayload ) ) {
                return this.props.history.push( backRoutePayload );
            } else {
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                    state: {  memberId: this.data.memberId, patientId: this.data.patientId }
                } );
            }
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <PriorAuthDetailView
                { ...this.data }
                { ...this.state }
                onNavActionClick={ this.handleNavActionClick }
            />
        );
    }
}

// set display name
_PriorAuthDetail.displayName = 'PriorAuthDetail';

// set default props
_PriorAuthDetail.defaultProps = {};

// prop types
_PriorAuthDetail.propTypes = {};


export const PriorAuthDetail = withRouter( _PriorAuthDetail );
